import React from 'react';
import { SkeletonPage, SkeletonBodyText, InlineStack, BlockStack, Layout, Card, SkeletonDisplayText, SkeletonTabs } from '@shopify/polaris';
import styles from './Skeleton.module.scss';

/**
 * FAQ页面骨架屏组件
 */
const FAQSkeleton: React.FC = () => {
  return (
    <SkeletonPage primaryAction>
      <Layout>
        <Layout.Section>
          <BlockStack gap="400">
            <Card>
              <BlockStack gap="400">
                <SkeletonBodyText />
                <SkeletonBodyText />
                <SkeletonBodyText />
              </BlockStack>
            </Card>
          </BlockStack>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );
};

export default FAQSkeleton; 